import React from 'react'
import { FieldEvaluationReportDialogLauncher } from '@/pages/Financing/components/FieldEvaluationReportDialogLauncher'
import { OPEN_DIALOG_DELAY_MS } from './constants'
import type { TFieldEvaluationReportDialogPublicLauncherProps } from './types'

export const FieldEvaluationReportDialogPublicLauncher = ({ comment }: TFieldEvaluationReportDialogPublicLauncherProps) => (
  <FieldEvaluationReportDialogLauncher comment={comment} timeout={OPEN_DIALOG_DELAY_MS} />
)
